export const templatesList = [
  "sand-profile",
  "editorial-muse",
  "slate-ledger",
  "blue-horizon",
  "dune-flow",
  "navy-summit",
  "silver-ledger",
  "royal-line",
  "cobalt-balance",
  "charcoal-monogram",
  "linen-ledger",
  "mono-content",
  "plum-timeline",
  "citrus-bloom",
  "blue-wave",
  "project-flow",
  "fresh-start",
  "legal-distinction",
  "fiscal-arch",
  "soft-contour",
  "brand-mocha",
  "forest-frame",
  "azure-frame",
  "sage-orbit",

  "code-clarity",
  "marketing-pulse",
  "people-first",
  "structural-line",
  "clinical-calm",
  "sales-focus",
  "account-balance",
] as const;

export type Template = (typeof templatesList)[number];

export const DEFAULT_TEMPLATE: Template = "project-flow";

export const isTemplate = (value: unknown): value is Template =>
  typeof value === "string" && (templatesList as readonly string[]).includes(value);

// Un modèle retiré du catalogue est remplacé par le modèle par défaut.
export const resolveTemplate = (value: unknown): Template =>
  isTemplate(value) ? value : DEFAULT_TEMPLATE;
